import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import {
  selectCurrentMeasure, selectCurrentMeasureId
} from '../../../features/measure/measure.selectors';
import {
  selectCurrentCut, selectCurrentCutId
} from '../../../features/cut/cut.selectors';
import {
  selectCurrentTrackerElevation, selectCurrentTrackerElevationId,
  selectCurrentTrackerImage, selectCurrentTrackerImageId
} from '../../../features/tracker/tracker.selectors';
import {
  selectCurrentDetection, selectCurrentDetectionId
} from '../../../features/detection/detection.selectors';
import {
  selectCurrentVolume, selectCurrentVolumeId
} from '../../../features/volume/volume.selectors';
import { Measure } from '../../../models/measure';
import { Cut } from '../../../models/cut';
import { TrackerElevation, TrackerImage } from '../../../models/tracker';
import { Detection } from '../../../models/detection';
import { Volume } from '../../../models/volume';
import { map } from 'rxjs/operators';
import {
  selectConfigItemDetailExpanded,
} from '../../../features/config/config.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  setConfigExpandItemDetail,
} from '../../../features/config/config.actions';



@Component({
    selector: 'items-detail',
    templateUrl: './items-detail.component.html',
    styleUrls: ['./items-detail.component.scss'],
    standalone: false
})
export class ItemsDetailComponent {

  detailExpanded: boolean = false;

  constructor(private store: Store) {
    this.handleConfig();
  }

  private handleConfig(): void {
    this.store.select(selectConfigItemDetailExpanded)
      .pipe(takeUntilDestroyed())
      .subscribe((expanded: boolean) => {
        this.detailExpanded = expanded;
      });
  }

  togglePanel(): void {
    this.store.dispatch(setConfigExpandItemDetail({expand: !this.detailExpanded}));
  }

  get measureSelected$(): Observable<Measure | null | undefined> {
    return this.store.select(selectCurrentMeasure)
  }
  get cutSelected$(): Observable<Cut | null | undefined> {
    return this.store.select(selectCurrentCut)
  }
  get elevationSelected$(): Observable<TrackerElevation | null | undefined> {
    return this.store.select(selectCurrentTrackerElevation)
  }
  get markerSelected$(): Observable<TrackerImage | null | undefined> {
    return this.store.select(selectCurrentTrackerImage)
  }
  get detectionSelected$(): Observable<Detection | null | undefined> {
    return this.store.select(selectCurrentDetection)
  }
  get volumeSelected$(): Observable<Volume | null | undefined> {
    return this.store.select(selectCurrentVolume)
  }
}
